<template>
  <div v-if="template == false">
    <div v-if="lang == 'ru'">
      <p class="title">Договор №{{ doc_id }}</p>
      <div style="display: flex; justify-content: space-between">
        <div>Город {{ city }}</div>
        <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
      </div>
      <p style="text-align: justify">
        {{ org1_type }} &laquo;{{ org1_name }}&raquo;, зарегистрированное по
        адресу: {{ org1_residency }}, {{ org1_address }}, именуемое в дальнейшем
        «Продавец» в лице {{ org1_ceo }}, действующего на основании Устава, с
        одной стороны, и {{ org2_type }} &laquo;{{ org2_name }}&raquo;,
        зарегистрированное по адресу: {{ org2_residency }}, {{ org2_address }},
        именуемое в дальнейшем «Покупатель», в лице {{ org2_ceo }}, действующего
        на основании Устава, с другой стороны, далее совместно именуемые
        «Стороны», подписали настоящий Контракт (далее – «Контракт») о
        нижеследующем.
      </p>
      <p class="subtitle">1. Предмет Контракта</p>
      <p style="text-align: justify">
        1.1. Продавец обязуется отгрузить, а Покупатель – купить на условиях
        {{ delivery_terms }} товары, номенклатура, ассортимент, вес, количество,
        требования к качеству и спецификация которых приведены в Приложении № 1
        к Контракту (далее – «Товары»), являющемся неотъемлемой частью
        Контракта.
      </p>
      <p>1.2. Страна происхождения Товаров – {{ goods_origin }}.</p>
      <p style="text-align: justify">
        1.3. По согласованию Сторон количество Товаров и их характеристики могут
        быть изменены путем подписания Сторонами дополнительного соглашения к
        Контракту.
      </p>
      <p style="text-align: justify">
        1.4. Пункт отправления: {{ delivery_from }}; пункт назначения:
        {{ delivery_country }}. Экспедитор: {{ courier_org_name }}.
      </p>
      <p class="subtitle">2. Общая стоимость Контракта и условия оплаты</p>
      <p style="text-align: justify">
        2.1. Цены на Товары оговариваются в предложениях Продавца и обозначаются
        в {{ contract_currency }}. Продавец имеет право изменять цены на Товары
        при условии оповещения Покупателя о предстоящем изменении не менее чем
        за {{ conditions.days_to_change_price }} ({{
          days_to_letters(conditions.days_to_change_price)
        }}) дней до такого изменения. Продавец не имеет права изменять цены на
        Товары в течение всего срока действия Контракта.
      </p>
      <p style="text-align: justify">
        2.2. Общая стоимость Контракта составляет {{ contract_total }} ({{
          money_letters(contract_total, contract_currency_code)
        }}) {{ contract_currency }} и включает в себя стоимость упаковки,
        погрузки Товаров и других расходов, соответствующих условиям поставки.
      </p>
      <p style="text-align: justify">
        2.3. {{ conditions.prepayment_percent }}% ({{
          percent_to_letters(conditions.prepayment_percent)
        }}) от общей стоимости Контракта подлежит оплате в течение
        {{ conditions.number_of_days_for_prepayment }} ({{
          days_to_letters(conditions.number_of_days_for_prepayment)
        }}) дней с даты выставления счета Продавцом. Оставшиеся
        {{ 100 - conditions.prepayment_percent }}% ({{
          percent_to_letters(100 - conditions.prepayment_percent)
        }}) от общей стоимости Контракта подлежат оплате Покупателем в течение
        {{ conditions.number_of_days_for_fullpayment }} ({{
          days_to_letters(conditions.number_of_days_for_fullpayment)
        }}) дней с даты завершения оформления документов по таможенной очистке
        Товаров.
      </p>
      <p style="text-align: justify">
        2.4. Все расходы по Контракту, включая таможенные и страховые платежи,
        уплачиваются Сторонами самостоятельно на территориях своих стран.
      </p>
      <p style="text-align: justify">
        2.5. Все платежи по Контракту осуществляются в безналичном порядке путем
        перевода денег на банковский счет Продавца, указанный в разделе 13
        Контракта, в {{ contract_currency }}.
      </p>
      <p class="subtitle">3. Права и обязанности Сторон</p>
      <p>
        <strong> 3.1. Продавец обязан: </strong>
      </p>
      <p style="text-align: justify">
        3.1.1. своевременно отгрузить Товары соответствующего качества,
        подтверждаемого сертификатами производителей (сертификат качества,
        сертификат соответствия), в ассортименте и количестве согласно
        Приложению № 1 к Контракту;
      </p>
      <p style="text-align: justify">
        3.1.2. упаковать Товары в соответствие с нормами и правилами,
        установленными при экспорте Товаров данного вида, с обеспечением
        сохранности качества и количества при их транспортировке;
      </p>
      <p style="text-align: justify">
        3.1.3. до момента отгрузки товара провести проверку качества Товаров,
        соответствия Товаров требованиям Покупателя. Результаты такой проверки
        Продавец оформляет соответствующим сертификатом качества, передаваемым
        Покупателю.
      </p>
      <p>
        <strong> 3.2. Продавец вправе: </strong>
      </p>
      <p style="text-align: justify">
        3.2.1. своевременно получить оплату за надлежащим образом поставленные
        Товары;
      </p>
      <p style="text-align: justify">
        3.2.2. отказаться от исполнения обязательств по Контракту в случае
        отсутствия оплаты за надлежащим образом поставленные Товары.
      </p>
      <p>
        <strong> 3.3. Покупатель обязан: </strong>
      </p>
      <p style="text-align: justify">
        3.3.1. своевременно оплатить стоимость надлежащим образом поставленных
        Товаров;
      </p>
      <p style="text-align: justify">
        3.3.2. осуществить приемку Товаров в порядке, установленном Контрактом.
      </p>
      <p>
        <strong> 3.4. Покупатель вправе: </strong>
      </p>
      <p style="text-align: justify">
        3.4.1. отказаться от исполнения обязательств по Контракту в случае не
        поставки Товаров Продавцом в срок, указанный в п. 4.3. Контракта;
      </p>
      <p style="text-align: justify">
        3.4.2. отказаться от исполнения обязательств по Контракту в случае
        поставки Товаров Продавцом в качестве и количестве, не соответствующим
        условиям Контракта.
      </p>
      <p class="subtitle">4. Сроки и условия поставки</p>
      <p>4.1. Условия поставки: {{ delivery_terms }}.</p>
      <p style="text-align: justify">
        4.2. Продавец обязуется отгрузить Товары в течение
        {{ conditions.shipping_term }} ({{
          days_to_letters(conditions.shipping_term)
        }}) дней с даты подписания Контракта.
      </p>
      <p style="text-align: justify">
        4.3. Общий срок поставки Товара составляет
        {{ conditions.total_delivery_time }} ({{
          days_to_letters(conditions.total_delivery_time)
        }}) дней. Поставка Товара осуществляется партиями, сформированными на
        основании письменных заказов Покупателя.
      </p>
      <p style="text-align: justify">
        4.4. Письменный заказ Покупателя считается принятым к исполнению, если
        Продавец выставил Покупателю счет на оплату, который вступает в силу с
        момента подтверждения Покупателем согласия на оплату по этому счету.
      </p>
      <p style="text-align: justify">
        4.5. Продавец обязан письменно известить Покупателя о факте отгрузки
        Товаров в кратчайшие сроки, сообщив следующие данные: дату отгрузки,
        информацию об экспедиторе, маршрут, номер Контракта, вид транспорта и
        регистрационная информация о транспортном средстве, номер
        товаросопроводительного документа, описание, количество и вес
        отгруженных Товаров, и иную информацию.
      </p>
      <p style="text-align: justify">
        4.6. Датой поставки считается дата получения Покупателем письменного
        уведомления от Продавца о прибытии Товаров в пункт назначения, указанный
        в п. 1.4. Контракта.
      </p>
      <p style="text-align: justify">
        4.7. С отгруженными Товарами Продавец направляет Покупателю следующие
        документы:
      </p>
      <p>4.7.1. грузовая таможенная декларация;</p>
      <p>4.7.2. инвойс (счет-фактура);</p>
      <p>4.7.3. товарно-транспортная накладная</p>
      <p>4.7.4. упаковочный лист;</p>
      <p>4.7.5. сертификат происхождения</p>
      <p style="text-align: justify">
        4.8. Продавец несет ответственность за правильность заполнения всех
        отгрузочных документов.
      </p>
      <p class="subtitle">5. Упаковка и маркировка</p>
      <p style="text-align: justify">
        5.1. Товары должны быть упакованы в соответствии с характером
        поставляемых Товаров, а также согласно требованиям безопасности и защиты
        каждого вида Товара. При этом внешняя и внутренняя упаковка Товаров
        должны обеспечивать их защиту от порчи, повреждения и атмосферных
        воздействий, с учетом возможных перегрузок в пути.
      </p>
      <p style="text-align: justify">
        5.2. Тара, в которую упакованы Товары, должна быть маркирована с трех
        сторон: верхней и двух противоположных друг другу боковых сторон. Все
        сопроводительные документы (упаковочные листы, спецификации) так же, как
        маркировка и техническая документация, должны быть составлены на
        английском языке.
      </p>
      <p style="text-align: justify">
        5.3. Маркировка должна содержать товаросопроводительную информацию
        (наименование Покупателя, пункт назначения, номер Контракта, массу
        брутто и нетто, размеры грузового места, его номер, наименование
        Продавца, название страны происхождения Товаров и иную информацию).
      </p>
      <p class="subtitle">6. Приемка Товаров</p>
      <p style="text-align: justify">
        6.1. Товар считается доставленным Продавцом и принятым Покупателем:
      </p>
      <p style="text-align: justify">
        6.1.1. по количеству – в соответствии с сопроводительными документами;
      </p>
      <p style="text-align: justify">
        6.1.2. по качеству – в соответствии с сертификатами качества, выданными
        производителем.
      </p>
      <p>6.2. Товары принимаются:</p>
      <p style="text-align: justify">
        6.2.1. по количеству содержимого в упаковке – не позднее
        {{ conditions.days_to_receive_goods }} ({{
          days_to_letters(conditions.days_to_receive_goods)
        }}) дней после получения Товаров, а также на момент вскрытия упаковки;
      </p>
      <p>
        6.2.2. по качеству – не позднее
        {{ conditions.days_to_quality_receive_goods }} ({{
          days_to_letters(conditions.days_to_quality_receive_goods)
        }}) дней после вскрытия упаковки.
      </p>
      <p style="text-align: justify">
        6.3. Приемка выполняется уполномоченным представителем Покупателя,
        действующим на основании соответствующей доверенности, с приглашением,
        при необходимости, представителя Продавца, с оформлением акта приемки.
      </p>
      <p style="text-align: justify">
        6.4. Право собственности на Товары, а также риск случайной гибели,
        утраты или случайного повреждения Товаров, переходит от Продавца к
        Покупателю с момента пересечения Товаров границы {{ org2_residency }}.
      </p>
      <p class="subtitle">7. Качество Товаров и гарантии</p>
      <p style="text-align: justify">
        7.1. Качество Товаров должно подтверждаться сертификатами качества,
        выданными производителем.
      </p>
      <p style="text-align: justify">
        7.2. Для Товаров, качество которых требует специальных гарантий,
        устанавливается гарантийный срок {{ conditions.guaranty_term }} ({{
          number_to_letters(conditions.guaranty_term)
        }}) месяцев со дня поставки.
      </p>
      <p style="text-align: justify">
        7.3. Если в течение гарантийного срока Товар, поставленный Продавцом,
        проявит дефекты или несоответствие условиям Контракта, Продавец обязан
        устранить дефект или заменить дефектные компоненты за свой счет.
        Доставка дефектных товаров при возврате выполняется за счет Продавца.
      </p>
      <p style="text-align: justify">
        7.4. Продавец гарантирует, что свойства, соответствующие назначению
        Товаров, будут сохраняться в течение гарантийного срока при соблюдении
        Покупателем установленных правил эксплуатации, использования и хранения
        Товаров.
      </p>
      <p class="subtitle">8. Претензии</p>
      <p style="text-align: justify">
        8.1. Покупатель может выдвинуть Продавцу [Поставщику] претензии по
        качеству и количеству Товаров в течение
        {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) дней со дня подписания Покупателем акта приемки Товаров.
      </p>
      <p style="text-align: justify">
        8.2. Претензии подтверждаются сертификатом независимой компетентной
        экспертной организации.
      </p>
      <p style="text-align: justify">
        8.3. Продавец [Поставщик] обязан удовлетворить претензию Покупателя в
        течение {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) дней с момента ее получения.
      </p>
      <p class="subtitle">9. Ответственность</p>
      <p style="text-align: justify">
        9.1. В случае просрочки платежа, Покупатель обязан оплатить Продавцу
        пеню в размере {{ conditions.payment_overdue }}% ({{
          percent_to_letters(conditions.payment_overdue)
        }}) от просроченной суммы за каждый день просрочки платежа.
      </p>
      <p style="text-align: justify">
        9.2. В случае если Продавец [Поставщик] не произвел отгрузку Товаров в
        течение {{ conditions.shipping_term }} ({{
          days_to_letters(conditions.shipping_term)
        }}) дней с момента подтверждения Покупателем согласия на оплату по
        выставленному счету, он обязан уплатить Покупателю пеню в размере
        {{ conditions.shipping_overdue }}% ({{
          percent_to_letters(conditions.shipping_overdue)
        }}) от стоимости неотгруженной партии Товаров за каждый день задержки.
      </p>
      <p style="text-align: justify">
        9.3. Продавец несет ответственность за убытки, связанные с повреждением
        или порчей Товаров, а также с отправкой Товаров по неверному адресу
        вследствие неполноценной или неправильной маркировки и упаковки.
      </p>
      <p style="text-align: justify">
        9.4. Уплата пени не освобождает виновную Сторону от выполнения
        обязательств, предусмотренных условиями Контракта.
      </p>
      <p class="subtitle">10. Форс-мажор</p>
      <p style="text-align: justify">
        10.1. В случае обстоятельств, делающих невозможным частичное или полное
        выполнение обязательств любой из Сторон, а именно: пожар, стихийные
        бедствия, война или боевые действия, эмбарго дата исполнения
        обязательств изменяется в соответствии с продолжительностью воздействия
        таких обстоятельств.
      </p>
      <p style="text-align: justify">
        10.2. Сторона, находящаяся под воздействием обстоятельств, делающих
        невозможным исполнение обязательств, должна незамедлительно
        информировать другую Сторону о наступлении или окончании таких
        обстоятельств. Документы из Торговой палаты стран Продавца и Покупателя,
        соответственно, будет подтверждать очевидность вышеупомянутых
        обстоятельств, их наличие и продолжительность.
      </p>
      <p style="text-align: justify">
        10.3. Если такие обстоятельства продолжаются более ___ месяцев, каждая
        из Сторон имеет право отказаться от дальнейшего исполнения обязательств,
        и в этом случае ни одна из Сторон не имеет права требовать возмещения
        понесенных убытков.
      </p>
      <p style="text-align: justify">
        10.4. Стороны обязуются выполнить свои обязательства по Контракту сразу
        после истечения форс-мажорных обстоятельств, за исключением случаев,
        предусмотренных п. 10.3. Контракта.
      </p>
      <p class="subtitle">11. Разрешение споров</p>
      <p style="text-align: justify">
        11.1. Применимым правом по Контракту признается законодательство
        Республики Казахстан
      </p>
      <p style="text-align: justify">
        11.2. Стороны примут все меры к разрешению всех споров и разногласий,
        могущих возникнуть в процессе исполнения обязательств по Контракту,
        путём переговоров.
      </p>
      <p style="text-align: justify">
        11.3. Любые споры и (или) разногласия между Сторонами, оставшиеся не
        урегулированными соглашением Сторон, подлежат окончательному
        урегулированию в
        {{ conditions.arbitrage_country.display_text }} арбитраже в соответствии
        с его действующим Регламентом. Место проведения арбитражного
        разбирательства – {{ conditions.arbitrage_country.display_text }}.
        Языком арбитражного разбирательства будет
        {{ conditions.contract_language.display_text }} язык.
      </p>
      <p class="subtitle">12. Прочие условия</p>
      <p style="text-align: justify">
        12.1. Стороны не вправе передавать свои права и обязательства по
        Контракту третьей стороне.
      </p>
      <p style="text-align: justify">
        12.2. Любые изменения и дополнения к Контракту являются его неотъемлемой
        частью и действительны только в случае, если они письменно оформлены и
        заверены подписями уполномоченных представителей обеих Сторон.
      </p>
      <p style="text-align: justify">
        12.3. Контракт составлен в 2 (двух) подлинных экземплярах на
        {{ conditions.contract_language.display_text }} языке, имеющих
        одинаковую юридическую силу, по одному экземпляру для каждой из Сторон.
      </p>
      <p style="text-align: justify">
        12.4. Настоящий Контракт вступает в силу с момента его подписания
        Сторонами и действует до {{ conditions.contract_term }}, а в части
        взаиморасчетов – до полного их исполнения.
      </p>
      <p style="text-align: justify">
        12.5. Все Приложения к Контракту являются его неотъемлемыми частями.
      </p>
      <p class="subtitle">13. Места нахождения и банковские реквизиты Сторон</p>
      <p style="text-align: justify">
        В случае изменений банковских реквизитов любой из Сторон, другая Сторона
        должна быть поставлена об этом в известность в письменном виде, и в
        течение {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) дней надлежит составить подписанное обеими Сторонами дополнительное
        соглашение к Контракту с актуальными банковскими реквизитами.
      </p>
      <div class="html2pdf__page-break"></div>
      <div class="table" style="">
        <table
          border="1"
          cellpadding="10"
          cellspacing="0"
          width="100%"
          style="border-style: solid"
        >
          <tr>
            <td>
              <strong>Продавец:</strong><br />
              {{ org1_name }},<br />
              {{ org1_residency }}<br />
              {{ org1_address }}<br />
              {{ org1_ceo }}
            </td>
            <td>
              <strong>Покупатель:</strong><br />
              {{ org2_name }},<br />
              {{ org2_residency }}<br />
              {{ org2_address }}<br />
              {{ org2_ceo }}
            </td>
          </tr>
          <tr>
            <td><strong>От Продавца:</strong><br /></td>
            <td><strong>От Покупателя:</strong><br /></td>
          </tr>
        </table>
      </div>
      <div style="page-break-after: always"></div>
      <div>
        <h3 style="text-align: center">Приложение 1</h3>
        <p>Список товаров по контракту</p>
        <div class="table" style="">
          <table
            border="1"
            cellpadding="10"
            cellspacing="0"
            width="100%"
            style="border-style: solid"
          >
            <thead>
              <th>N<sup>o</sup> п/п</th>
              <th>ТНВЭД</th>
              <th>Наименование</th>
              <th>Количество</th>
              <th>Цена</th>
            </thead>
            <tr v-for="(good, i) in goods" :key="i">
              <td>
                {{ i + 1 }}
              </td>
              <td>
                {{ good.attis_cg_TNVED.value }} -
                {{ good.attis_cg_TNVED.display_text }}
              </td>
              <td>
                {{ good.attis_cg_good_name }}
              </td>
              <td>
                {{ good.attis_cg_quantity }}
              </td>
              <td>
                {{ good.attis_cg_price }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div v-if="lang == 'en'">
      <p class="title">Contract No{{ doc_id }}</p>
      <div style="display: flex; justify-content: space-between">
        <div>Location {{ city }}</div>
        <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
      </div>
      <p style="text-align: justify">
        {{ org1_type }} &laquo;{{ org1_name }}&raquo;, having its registered
        address: {{ org1_residency }}, {{ org1_address }}, hereinafter referred
        to as "Seller" represented by {{ org1_ceo }}, acting on the basis of
        Statute, on the one side, and {{ org2_type }} &laquo;{{
          org2_name
        }}&raquo;, having its registered address: {{ org2_residency }},
        {{ org2_address }}, hereinafter referred to as the "Buyer", represented
        by {{ org2_ceo }}, acting on the basis of Statute, on the other side,
        hereinafter jointly referred to as the "Parties" have signed this
        Contract (hereinafter referred to as the "Contract") as follows.
      </p>
      <p class="subtitle">1. Subject of the Contract</p>
      <p style="text-align: justify">
        1.1. The Seller undertakes to ship, and the Buyer - to buy on the terms
        {{ delivery_terms }} goods, nomenclature, assortment, weight, quantity,
        quality requirements and specifications of which are given in Appendix
        No. 1 to the Contract (hereinafter - "Goods"), which is an integral part
        of the Contract.
      </p>
      <p>1.2. The country of origin of the Goods – {{ goods_origin }}.</p>
      <p style="text-align: justify">
        1.3. By agreement of the Parties, the number of Goods and their
        characteristics may be changed by signing an additional agreement to the
        Contract by the Parties.
      </p>
      <p style="text-align: justify">
        1.4. Departure Point: {{ delivery_from }}; Destination Point:
        {{ delivery_country }}. Forwarder: {{ courier_org_name }}.
      </p>
      <p class="subtitle">2. Total Cost of the Contract and Terms of Payment</p>
      <p style="text-align: justify">
        2.1. Prices for the Goods are negotiated in the offers of the Seller and
        are indicated in {{ contract_currency }}. The Seller has the right to
        change the prices for the Goods, provided that the Buyer is notified of
        the upcoming change at least {{ conditions.days_to_change_price }} ({{
          days_to_letters(conditions.days_to_change_price)
        }}) days before such a change. The Seller has no right to change the
        prices of the Goods during the entire term of the Contract.
      </p>
      <p style="text-align: justify">
        2.2. The total cost of the Contract is {{ contract_total }} ({{
          money_letters(contract_total, contract_currency_code)
        }}) {{ contract_currency }} and includes the cost of packaging, loading
        of the Goods and other expenses corresponding to the terms of delivery.
      </p>
      <p style="text-align: justify">
        2.3. {{ conditions.prepayment_percent }}% ({{
          percent_to_letters(conditions.prepayment_percent)
        }}) of the total cost of the Contract is payable within
        {{ conditions.number_of_days_for_prepayment }} ({{
          days_to_letters(conditions.number_of_days_for_prepayment)
        }}) days from the date of the invoice by the Seller. The remaining
        {{ 100 - conditions.prepayment_percent }}% ({{
          percent_to_letters(100 - conditions.prepayment_percent)
        }}) of the total cost of the Contract is payable by the Buyer within
        {{ conditions.number_of_days_for_fullpayment }} ({{
          days_to_letters(conditions.number_of_days_for_fullpayment)
        }}) days from the date of completion of the documents for customs
        clearance of the Goods.
      </p>
      <p style="text-align: justify">
        2.4. All costs under the Contract, including customs and insurance
        payments, shall be paid by the Parties on their own in the territories
        of their countries.
      </p>
      <p style="text-align: justify">
        2.5.All payments under the Contract are made by bank transfer to the
        bank account of the Seller specified in section 13 of the Contract, in
        {{ contract_currency }}.
      </p>
      <p class="subtitle">3. Rights and obligations of the Parties</p>
      <p>
        <strong> 3.1. The Seller is obliged: </strong>
      </p>
      <p style="text-align: justify">
        3.1.1. timely dispatch the Goods of appropriate quality, confirmed by
        the manufacturers' certificates (quality certificate, certificate of
        conformity), in the range and quantity in accordance with Appendix No. 1
        to the Contract;
      </p>
      <p style="text-align: justify">
        3.1.2. pack the Goods in accordance with the rules and regulations
        established for the export of Goods of this type, ensuring the safety of
        quality and quantity during their transportation;
      </p>
      <p style="text-align: justify">
        3.1.3. before the shipment of the goods, to check the quality of the
        Goods, the conformity of the Goods to the Buyer's requirements. The
        results of such a check are issued by the Seller with an appropriate
        quality certificate, which is transferred to the Buyer.
      </p>
      <p>
        <strong> 3.2. The Seller has the right: </strong>
      </p>
      <p style="text-align: justify">
        3.2.1. receive timely payment for properly delivered Goods;
      </p>
      <p style="text-align: justify">
        3.2.2. refuse to fulfill obligations under the Contract in the absence
        of payment for duly delivered Goods.
      </p>
      <p>
        <strong> 3.3. The buyer is obliged: </strong>
      </p>
      <p style="text-align: justify">
        3.3.1. pay the cost of duly delivered Goods in a timely manner;
      </p>
      <p style="text-align: justify">
        3.3.2. carry out acceptance of the Goods in the manner prescribed by the
        Contract.
      </p>
      <p>
        <strong> 3.4. The Buyer has the right: </strong>
      </p>
      <p style="text-align: justify">
        3.4.1. refuse to fulfill obligations under the Contract if the Seller
        does not supply the Goods within the time period specified in clause
        4.3. Contract;
      </p>
      <p style="text-align: justify">
        3.4.2. refuse to fulfill obligations under the Contract in the event
        that the Goods are delivered by the Seller in a quality and quantity
        that does not correspond to the terms of the Contract.
      </p>
      <p class="subtitle">4. Terms and conditions of delivery</p>
      <p>4.1. Terms of delivery: {{ delivery_terms }}.</p>
      <p style="text-align: justify">
        4.2. The Seller [Supplier] undertakes to ship the Goods within
        {{ conditions.shipping_term }} ({{
          days_to_letters(conditions.shipping_term)
        }}) days from the date of signing the Contract.
      </p>
      <p style="text-align: justify">
        4.3. The total delivery time for the Goods is
        {{ conditions.total_delivery_time }} ({{
          days_to_letters(conditions.total_delivery_time)
        }}) days. The delivery of the Goods is carried out in batches, formed on
        the basis of written orders of the Buyer.
      </p>
      <p style="text-align: justify">
        4.4. A written order of the Buyer is considered accepted for execution
        if the Seller has issued an invoice to the Buyer for payment, which
        comes into force from the moment the Buyer confirms his consent to pay
        on this invoice.
      </p>
      <p style="text-align: justify">
        4.5. The Seller is obliged to notify the Buyer in writing of the fact of
        shipment of the Goods as soon as possible, providing the following data:
        date of shipment, information about the forwarder, route, Contract
        number, mode of transport and registration information about the
        vehicle, number of the shipping document, description, the number and
        weight of the Goods shipped, and other information.
      </p>
      <p style="text-align: justify">
        4.6. The date of delivery is the date of receipt by the Buyer of a
        written notice from the Seller about the arrival of the Goods at the
        destination specified in clause 1.4. Of the Contract.
      </p>
      <p style="text-align: justify">
        4.7. With the shipped Goods, the Seller sends the following documents to
        the Buyer:
      </p>
      <p>4.7.1. cargo customs declaration;</p>
      <p>4.7.2. invoice;</p>
      <p>4.7.3. consignment note</p>
      <p>4.7.4. packing list;</p>
      <p>4.7.5. certificate of origin</p>
      <p style="text-align: justify">
        4.8. The Seller is responsible for the correct completion of all
        shipping documents.
      </p>
      <p class="subtitle">5. Packaging and labeling</p>
      <p style="text-align: justify">
        5.1. The Goods must be packed in accordance with the nature of the Goods
        supplied, as well as in accordance with the safety and security
        requirements of each type of Goods. At the same time, the outer and
        inner packaging of the Goods must ensure their protection against
        spoilage, damage and atmospheric influences, taking into account
        possible overloads on the way.
      </p>
      <p style="text-align: justify">
        5.2. The container in which the Goods are packed must be marked on three
        sides: the top and two opposite sides. All accompanying documents
        (packing lists, specifications) as well as marking and technical
        documentation must be in English.
      </p>
      <p style="text-align: justify">
        5.3. The marking must contain shipping information (name of the Buyer,
        point of destination, number of the Contract, gross and net weight, size
        of the package, its number, name of the Seller, name of the country of
        origin of the Goods and other information).
      </p>
      <p class="subtitle">6. Acceptance of Goods</p>
      <p style="text-align: justify">
        6.1. The goods are considered delivered by the Seller and accepted by
        the Buyer:
      </p>
      <p style="text-align: justify">
        6.1.1. by quantity - in accordance with the accompanying documents;
      </p>
      <p style="text-align: justify">
        6.1.2. by quality - in accordance with the quality certificates issued
        by the manufacturer.
      </p>
      <p>6.2. Goods are accepted:</p>
      <p style="text-align: justify">
        6.2.1. by the amount of content in the package - no later than
        {{ conditions.days_to_receive_goods }} ({{
          days_to_letters(conditions.days_to_receive_goods)
        }}) days after receiving the Goods, as well as at the time of opening
        the package;
      </p>
      <p>
        6.2.2. for quality - no later than
        {{ conditions.days_to_quality_receive_goods }} ({{
          days_to_letters(conditions.days_to_quality_receive_goods)
        }}) days after opening the package.
      </p>
      <p style="text-align: justify">
        6.3. Acceptance is carried out by an authorized representative of the
        Buyer, acting on the basis of an appropriate power of attorney, with the
        invitation, if necessary, of a representative of the Seller, with the
        execution of an acceptance certificate.
      </p>
      <p style="text-align: justify">
        6.4. Ownership of the Goods, as well as the risk of accidental loss,
        loss or accidental damage to the Goods, passes from the Seller to the
        Buyer from the moment the Goods cross the border of the
        {{ org2_residency }}.
      </p>
      <p class="subtitle">7. Product quality and guarantees</p>
      <p style="text-align: justify">
        7.1. The quality of the Goods must be confirmed by quality certificates
        issued by the manufacturer.
      </p>
      <p style="text-align: justify">
        7.2. For Goods, the quality of which requires special guarantees, a
        warranty period of {{ conditions.guaranty_term }} ({{
          number_to_letters(conditions.guaranty_term)
        }}) months from the date of delivery is established.
      </p>
      <p style="text-align: justify">
        7.3. If, during the warranty period, the Goods supplied by the Seller
        show defects or non-conformity with the terms of the Contract, the
        Seller is obliged to eliminate the defect or replace the defective
        components at its own expense. Delivery of defective goods upon return
        is carried out at the expense of the Seller.
      </p>
      <p style="text-align: justify">
        7.4. The Seller guarantees that the properties corresponding to the
        purpose of the Goods will be preserved during the warranty period,
        subject to the Buyer's observance of the established rules for the
        operation, use and storage of the Goods.
      </p>
      <p class="subtitle">8. Complaints</p>
      <p style="text-align: justify">
        8.1. The Buyer may make claims to the Seller [Supplier] for the quality
        and quantity of the Goods within {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) days from the date of the Buyer's signing of the act of acceptance
        of the Goods.
      </p>
      <p style="text-align: justify">
        8.2. Claims are confirmed by a certificate from an independent competent
        expert organization.
      </p>
      <p style="text-align: justify">
        8.3. The Seller [Supplier] is obliged to satisfy the Buyer's claim
        within {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) days from the date of its receipt.
      </p>
      <p class="subtitle">9. Responsibility</p>
      <p style="text-align: justify">
        9.1. In the event of a delay in payment, the Buyer is obliged to pay the
        Seller [Supplier] a penalty in the amount of
        {{ conditions.payment_overdue }}% ({{
          percent_to_letters(conditions.payment_overdue)
        }}) of the overdue amount for each day of delay in payment.
      </p>
      <p style="text-align: justify">
        9.2. If the Seller [Supplier] has not shipped the Goods within
        {{ conditions.shipping_term }} ({{
          days_to_letters(conditions.shipping_term)
        }}) days from the moment the Buyer confirms his consent to payment on
        the invoice [invoice], he must pay the Buyer a penalty in the amount of
        {{ conditions.shipping_overdue }}% ({{
          percent_to_letters(conditions.shipping_overdue)
        }}) of the cost of the unshipped consignment of Goods for each day of
        delay.
      </p>
      <p style="text-align: justify">
        9.3. The Seller [Supplier] shall be liable for losses associated with
        damage or deterioration of the Goods, as well as with the dispatch of
        the Goods to the wrong address due to defective or incorrect labeling
        and packaging.
      </p>
      <p style="text-align: justify">
        9.4. Payment of penalty interest does not relieve the guilty Party from
        fulfilling the obligations stipulated by the terms of the Contract.
      </p>
      <p class="subtitle">10. Force majeure</p>
      <p style="text-align: justify">
        10.1. In the event of circumstances that make it impossible to partially
        or fully fulfill the obligations of any of the Parties, namely: fire,
        natural disasters, war or hostilities, embargo, the date of fulfillment
        of obligations changes in accordance with the duration of the impact of
        such circumstances.
      </p>
      <p style="text-align: justify">
        10.2. A Party under the influence of circumstances that make it
        impossible to fulfill obligations must immediately inform the other
        Party about the occurrence or end of such circumstances. Documents from
        the Chamber of Commerce of the countries of the Seller [Supplier] and
        the Buyer, respectively, will confirm the evidence of the above
        circumstances, their presence and duration.
      </p>
      <p style="text-align: justify">
        10.3. If such circumstances continue for more than ___ months, each of
        the Parties has the right to refuse further fulfillment of obligations,
        and in this case, neither of the Parties has the right to claim
        compensation for losses incurred.
      </p>
      <p style="text-align: justify">
        10.4. The Parties undertake to fulfill their obligations under the
        Contract immediately after the expiration of force majeure, except as
        otherwise provided for p. 10.3. Contract.
      </p>
      <p class="subtitle">11. Dispute Resolution</p>
      <p style="text-align: justify">
        11.1. The applicable law under the Contract is the legislation of the
        Republic of Kazakhstan
      </p>
      <p style="text-align: justify">
        11.2. The parties will take all measures to resolve all disputes and
        disagreements that may arise in the process of fulfilling obligations
        under the Contract, through negotiations.
      </p>
      <p style="text-align: justify">
        11.3. Any disputes and (or) disagreements between the Parties that
        remain not settled by the agreement of the Parties are subject to final
        settlement in
        {{ conditions.arbitrage_country.display_text }} arbitration in
        accordance with its current Regulations. The place of the arbitration is
        – {{ conditions.arbitrage_country.display_text }}. The language of the
        arbitration shall be
        {{ conditions.contract_language.display_text }} language.
      </p>
      <p class="subtitle">12. Other conditions</p>
      <p style="text-align: justify">
        12.1. The parties are not entitled to transfer their rights and
        obligations under the Contract to a third party.
      </p>
      <p style="text-align: justify">
        12.2. Any changes and additions to the Contract are its integral part
        and are valid only if they are executed in writing and certified by the
        signatures of authorized representatives of both Parties.
      </p>
      <p style="text-align: justify">
        12.3. The contract is drawn up in 2 (two) original copies in the
        {{ conditions.contract_language.display_text }} language, having the
        same legal force, one copy for each of the Parties.
      </p>
      <p style="text-align: justify">
        12.4. This Contract comes into force from the moment of its signing by
        the Parties and is valid until {{ conditions.contract_term }}, and in
        terms of mutual settlements - until their full execution.
      </p>
      <p style="text-align: justify">
        12.5. All Appendices to the Contract are its integral parts.
      </p>
      <p class="subtitle">13. Locations and bank details of the Parties</p>
      <p style="text-align: justify">
        In case of changes in the bank details of any of the Parties, the other
        Party must be notified of this in writing, and within
        {{ conditions.notification_term }} ({{
          days_to_letters(conditions.notification_term)
        }}) days it is necessary to draw up an additional agreement signed by
        both Parties to the Contract with the current bank details.
      </p>
      <div class="html2pdf__page-break"></div>
      <div class="table" style="">
        <table
          border="1"
          cellpadding="10"
          cellspacing="0"
          width="100%"
          style="border-style: solid"
        >
          <tr>
            <td>
              <strong>Seller:</strong><br />
              {{ org1_name }},<br />
              {{ org1_residency }}<br />
              {{ org1_address }}<br />
              {{ org1_ceo }}
            </td>
            <td>
              <strong>Buyer:</strong><br />
              {{ org2_name }},<br />
              {{ org2_residency }}<br />
              {{ org2_address }}<br />
              {{ org2_ceo }}
            </td>
          </tr>
          <tr>
            <td><strong>On behalf of Seller:</strong><br /></td>
            <td><strong>On behalf of Buyer:</strong><br /></td>
          </tr>
        </table>
      </div>
      <div style="page-break-after: always"></div>
      <div>
        <h3 style="text-align: center">Attachment 1</h3>
        <p>List of goods of the Contract</p>
        <div class="table" style="">
          <table
            border="1"
            cellpadding="10"
            cellspacing="0"
            width="100%"
            style="border-style: solid"
          >
            <thead>
              <th>N<sup>o</sup></th>
              <th>HS</th>
              <th>Title</th>
              <th>Qty</th>
              <th>Price</th>
            </thead>
            <tr v-for="(good, i) in goods" :key="i">
              <td>
                {{ i + 1 }}
              </td>
              <td>
                {{ good.attis_cg_TNVED.value }} -
                {{ good.attis_cg_TNVED.display_text }}
              </td>
              <td>
                {{ good.attis_cg_good_name }}
              </td>
              <td>
                {{ good.attis_cg_quantity }}
              </td>
              <td>
                {{ good.attis_cg_price }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
  <div v-else>
    <div v-html="pugTemplate"></div>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
import pug from "pug";
var QRCode = require("qrcode");

export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional", "template"],
  data() {
    return {
      pugTemplate: null,
      org1_type: "",
      org1_name: "",
      org1_ceo: "",
      org1_residency: "",
      org1_address: "",
      org1_code: "",

      org2_type: "",
      org2_name: "",
      org2_ceo: "",
      org2_residency: "",
      org2_address: "",
      org2_code: "",

      city: "", // no way to get

      conditions: {
        days_to_change_price: "",
        prepayment_percent: "",
        number_of_days_for_prepayment: "",
        prepayment_percent: "",
        number_of_days_for_fullpayment: "",
        shipping_term: "",
        total_delivery_time: "",
        days_to_receive_goods: "",
        days_to_quality_receive_goods: "",
        guaranty_term: "",
        notification_term: "",
        notification_term: "",
        payment_overdue: "",
        shipping_term: "",
        shipping_overdue: "",
        arbitrage_country: { display_text: "" },
        contract_language: { display_text: "" },
        contract_term: "",
        notification_term: "",
      },

      // delivery_terms: '',
      goods_origin: "",
      delivery_from: "",
      delivery_address: "",
      courier_org_name: "",
      // contract_currency: '',
      contract_total: 0,
      contract_total_textual: "",
      delivery_country: "",

      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
      invoice: {},
      currencies: [],
      buyer: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
      seller: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
    };
  },
  mounted() {
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");

    this.conditions.days_to_change_price =
      this.doc_additional.days_to_change_price;
    this.conditions.prepayment_percent = this.doc_additional.prepayment_percent;
    this.conditions.number_of_days_for_prepayment =
      this.doc_additional.number_of_days_for_prepayment;
    this.conditions.prepayment_percent = this.doc_additional.prepayment_percent;
    this.conditions.number_of_days_for_fullpayment =
      this.doc_additional.number_of_days_for_fullpayment;
    this.conditions.shipping_term = this.doc_additional.shipping_term;
    this.conditions.total_delivery_time =
      this.doc_additional.total_delivery_time;
    this.conditions.days_to_receive_goods =
      this.doc_additional.days_to_receive_goods;
    this.conditions.days_to_quality_receive_goods =
      this.doc_additional.days_to_quality_receive_goods;
    this.conditions.guaranty_term = this.doc_additional.guaranty_term;
    this.conditions.notification_term = this.doc_additional.notification_term;
    this.conditions.notification_term = this.doc_additional.notification_term;
    this.conditions.payment_overdue = this.doc_additional.payment_overdue;
    this.conditions.shipping_term = this.doc_additional.shipping_term;
    this.conditions.shipping_overdue = this.doc_additional.shipping_overdue;
    this.conditions.arbitrage_country = this.doc_additional.arbitrage_country;
    if (
      typeof this.conditions.arbitrage_country === "undefined" ||
      typeof this.conditions.arbitrage_country.display_text === "undefined"
    ) {
      this.conditions.arbitrage_country = { display_text: "" };
    }
    this.conditions.contract_language = this.doc_additional.contract_language;
    if (
      typeof this.conditions.contract_language === "undefined" ||
      typeof this.conditions.contract_language.display_text === "undefined"
    ) {
      this.conditions.contract_language = { display_text: "" };
    }
    this.conditions.contract_term = this.doc_additional.contract_term;
    this.conditions.notification_term = this.doc_additional.notification_term;
    if (this.$store.state.firmfull == false) {
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        this.$store.commit("load_firm", response.data);
        if (this.doc.attis_contract_type === false) {
          axios
            .get(
              window.base +
                "/library/org_type?code=" +
                response.data.organizations.org_type +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.org1_type = resp.data[0].display_text;
            });

          this.org1_name = response.data.organizations.org_name;
          this.org1_code = response.data.organizations.org_code;
          this.org1_ceo = response.data.organizations.company_ceo;
          this.org1_residency = response.data.org_residency.display_text;
          response.data.addresses.forEach((address) => {
            if (address.subj_post_addr_type == 1) {
              this.org1_address = this.form_address(address);
            }
          });
        } else {
          axios
            .get(
              window.base +
                "/library/org_type?code=" +
                response.data.organizations.org_type +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.org2_type = resp.data[0].display_text;
            });

          this.org2_name = response.data.organizations.org_name;
          this.org2_code = response.data.organizations.org_code;
          this.org2_ceo = response.data.organizations.company_ceo;
          this.org2_residency = response.data.org_residency.display_text;
          response.data.addresses.forEach((address) => {
            if (address.subj_post_addr_type == 1) {
              this.org2_address = this.form_address(address);
            }
          });
        }

        axios
          .get(
            window.base +
              "/document/getFirmbyBin?bin=" +
              this.doc.attis_contract_contragent.value,
          )
          .then((response) => {
            if (this.doc.attis_contract_type === false) {
              axios
                .get(
                  window.base +
                    "/library/org_type?code=" +
                    response.data.organizations.org_type +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((resp) => {
                  if (
                    typeof resp.data[0] !== "undefined" &&
                    typeof resp.data[0].display_text !== "undefined"
                  )
                    this.org2_type = resp.data[0].display_text;
                });
              this.org2_name = response.data.organizations.org_name;
              this.org2_ceo = response.data.organizations.company_ceo;
              this.org2_code = response.data.organizations.org_code;
              this.org2_residency = response.data.org_residency.display_text;
              response.data.addresses.forEach((address) => {
                if (address.subj_post_addr_type == 1) {
                  this.org2_address = this.form_address(address);
                }
              });
            } else {
              axios
                .get(
                  window.base +
                    "/library/org_type?code=" +
                    response.data.organizations.org_type +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((resp) => {
                  if (
                    typeof resp.data[0] !== "undefined" &&
                    typeof resp.data[0].display_text !== "undefined"
                  )
                    this.org1_type = resp.data[0].display_text;
                });
              this.org1_name = response.data.organizations.org_name;
              this.org1_ceo = response.data.organizations.company_ceo;
              this.org1_code = response.data.organizations.org_code;
              this.org1_residency = response.data.org_residency.display_text;
              response.data.addresses.forEach((address) => {
                if (address.subj_post_addr_type == 1) {
                  this.org1_address = this.form_address(address);
                }
              });
            }

            axios
              .get(window.base + "/document?attis_contract_id=" + this.doc_id)
              .then((dr) => {
                dr.data.forEach((item) => {
                  if (item.DocType == "Инвойс") {
                    axios
                      .get(
                        window.base +
                          "/Document/LoadInvoice/?doc_id=" +
                          item.DocumentID,
                      )
                      .then((ir) => {
                        let countries = [];
                        let total = 0;
                        ir.data.product.forEach((p) => {
                          total +=
                            parseFloat(p.Price) * parseFloat(p.GoodsQuantity) +
                            parseFloat(p.OtherCharges) +
                            parseFloat(p.ServiceCharges) +
                            parseFloat(p.TransportCharges);
                          if (p.OriginCountryCode !== "") {
                            countries.push(p.OriginCountryCode);
                          }
                        });
                        if (
                          typeof countries !== "undefined" &&
                          countries.length > 0
                        ) {
                          axios
                            .get(
                              window.base +
                                "/library/country?code=" +
                                countries[0] +
                                "&lang=" +
                                this.$i18n.locale,
                            )
                            .then((c) => {
                              this.goods_origin = c.data[0].display_text;
                            });
                        }
                        this.contract_total += total;
                      });
                  }
                  if (item.DocType == "CMR") {
                    axios
                      .get(
                        window.base +
                          "/Document/LoadCMR/?doc_id=" +
                          item.DocumentID,
                      )
                      .then((cmr) => {
                        this.delivery_country = cmr.data.DeliveryPlace;
                        this.delivery_from =
                          cmr.data.City + ", " + cmr.data.StreetHouse;
                        // this.delivery_address =
                        if (cmr.data.cmr_courier !== "") {
                          axios
                            .get(
                              window.base +
                                "/document/getFirmbyBin?bin=" +
                                cmr.data.cmr_courier,
                            )
                            .then((courier) => {
                              this.courier_org_name =
                                courier.data.organizations.org_name;
                            });
                        }
                      });
                  }
                });
                if (this.template) {
                  const compiledFunction = pug.compile(this.template);
                  this.pugTemplate = compiledFunction({
                    doc_id: this.doc_id,
                    city: this.city,
                    day: this.day,
                    month: this.month,
                    year: this.year,
                    org1_type: this.org1_type,
                    org1_name: this.org1_name,
                    org1_residency: this.org1_residency,
                    org1_address: this.org1_address,
                    org1_ceo: this.org1_ceo,
                    org2_type: this.org2_type,
                    org2_name: this.org2_name,
                    org2_residency: this.org2_residency,
                    org2_address: this.org2_address,
                    org2_ceo: this.org2_ceo,
                    delivery_terms: this.delivery_terms,
                    goods_origin: this.goods_origin,
                    delivery_from: this.delivery_from,
                    delivery_country: this.delivery_country,
                    courier_org_name: this.courier_org_name,
                    contract_currency: this.contract_currency,
                    conditions: this.conditions,
                    days_to_change_price: this.days_to_letters(
                      this.conditions.days_to_change_price,
                    ),
                    contract_total: this.contract_total,
                    contract_money_letters: this.money_letters(
                      this.contract_total,
                      this.contract_currency_code,
                    ),
                    contract_currency: this.contract_currency,
                    prepayment_percent: this.percent_to_letters(
                      this.conditions.prepayment_percent,
                    ),
                    prepayment_days: this.days_to_letters(
                      this.conditions.number_of_days_for_prepayment,
                    ),
                    conditions100percent: this.percent_to_letters(
                      100 - this.conditions.prepayment_percent,
                    ),
                    conditions100days: this.days_to_letters(
                      this.conditions.number_of_days_for_fullpayment,
                    ),
                    goods: this.goods,
                  });
                }
                setTimeout(() => {
                  //load signature from database
                  axios
                    .get(
                      window.base +
                        "/contract/LoadSignature?doc_id=" +
                        this.doc_id,
                    )
                    .then((response) => {
                      if (typeof response.data.signature !== "undefined") {
                        if (response.data.signature == "") {
                          this.$root.$emit("print-pdf", {
                            signature: "",
                            type: "contract",
                          });
                          new Noty({
                            theme: "light",
                            type: "error",
                            text: this.$t(
                              "message.contracts.no-signature-message",
                            ),
                            timeout: 5000,
                          }).show();
                        } else {
                          var canvas = QRCode.toCanvas(
                            response.data.signature,
                            { width: 100, height: 100 },
                          );
                          canvas.then((r) => {
                            // this.check_signature(value, ()=>{
                            this.$root.$emit("print-pdf", {
                              signature: r,
                              type: "contract",
                            });
                            new Noty({
                              theme: "light",
                              type: "success",
                              text: this.$t(
                                "message.contracts.yes-signature-message",
                              ),
                              timeout: 5000,
                            }).show();
                            // window.webSocket.removeEventListener('message', {})
                            // })
                          });
                        }
                      } else {
                        this.$root.$emit("print-pdf", {
                          signature: "",
                          type: "contract",
                        });
                        new Noty({
                          theme: "light",
                          type: "error",
                          text: this.$t(
                            "message.contracts.no-signature-message",
                          ),
                          timeout: 5000,
                        }).show();
                      }
                    });
                }, 1000);
              });
          });
      });
    } else {
      let response = { data: {} };
      response.data = this.$store.state.firmfull;
      if (this.doc.attis_contract_type === false) {
        if (typeof response.data.organizations.org_type !== "object") {
          axios
            .get(
              window.base +
                "/library/org_type?code=" +
                response.data.organizations.org_type +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.org1_type = resp.data[0].display_text;
            });
        }

        this.org1_name = response.data.organizations.org_name;
        this.org1_code = response.data.organizations.org_code;
        this.org1_ceo = response.data.organizations.company_ceo;
        this.org1_residency = response.data.org_residency.display_text;
        // this.org1_address = response.data.persons.post_address
        response.data.addresses.forEach((address) => {
          if (address.subj_post_addr_type == 1) {
            this.org1_address = this.form_address(address);
          }
        });
      } else {
        if (typeof response.data.organizations.org_type !== "object") {
          axios
            .get(
              window.base +
                "/library/org_type?code=" +
                response.data.organizations.org_type +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((resp) => {
              this.org2_type = resp.data[0].display_text;
            });
        }

        this.org2_name = response.data.organizations.org_name;
        this.org2_code = response.data.organizations.org_code;
        this.org2_ceo = response.data.organizations.company_ceo;
        this.org2_residency = response.data.org_residency.display_text;
        // this.org2_address = response.data.persons.post_address
        response.data.addresses.forEach((address) => {
          if (address.subj_post_addr_type == 1) {
            this.org2_address = this.form_address(address);
          }
        });
      }

      axios
        .get(
          window.base +
            "/document/getFirmbyBin?bin=" +
            this.doc.attis_contract_contragent.value,
        )
        .then((response) => {
          if (this.doc.attis_contract_type === false) {
            axios
              .get(
                window.base +
                  "/library/org_type?code=" +
                  response.data.organizations.org_type +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                if (
                  typeof resp.data[0] !== "undefined" &&
                  typeof resp.data[0].display_text !== "undefined"
                )
                  this.org2_type = resp.data[0].display_text;
              });
            this.org2_name = response.data.organizations.org_name;
            this.org2_ceo = response.data.organizations.company_ceo;
            this.org2_code = response.data.organizations.org_code;
            this.org2_residency = response.data.org_residency.display_text;
            // this.org2_address = response.data.persons.post_address
            response.data.addresses.forEach((address) => {
              if (address.subj_post_addr_type == 1) {
                this.org2_address = this.form_address(address);
              }
            });
          } else {
            axios
              .get(
                window.base +
                  "/library/org_type?code=" +
                  response.data.organizations.org_type +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                if (
                  typeof resp.data[0] !== "undefined" &&
                  typeof resp.data[0].display_text !== "undefined"
                )
                  this.org1_type = resp.data[0].display_text;
              });
            this.org1_name = response.data.organizations.org_name;
            this.org1_ceo = response.data.organizations.company_ceo;
            this.org1_code = response.data.organizations.org_code;
            this.org1_residency = response.data.org_residency.display_text;
            // this.org1_address = response.data.persons.post_address
            response.data.addresses.forEach((address) => {
              if (address.subj_post_addr_type == 1) {
                this.org1_address = this.form_address(address);
              }
            });
          }

          axios
            .get(window.base + "/document?attis_contract_id=" + this.doc_id)
            .then((dr) => {
              dr.data.forEach((item) => {
                if (item.DocType == "Инвойс") {
                  axios
                    .get(
                      window.base +
                        "/Document/LoadInvoice/?doc_id=" +
                        item.DocumentID,
                    )
                    .then((ir) => {
                      let countries = [];
                      let total = 0;
                      ir.data.product.forEach((p) => {
                        total +=
                          parseFloat(p.Price) * parseFloat(p.GoodsQuantity) +
                          parseFloat(p.OtherCharges) +
                          parseFloat(p.ServiceCharges) +
                          parseFloat(p.TransportCharges);
                        if (p.OriginCountryCode !== "") {
                          countries.push(p.OriginCountryCode);
                        }
                      });
                      if (
                        typeof countries !== "undefined" &&
                        countries.length > 0
                      ) {
                        axios
                          .get(
                            window.base +
                              "/library/country?code=" +
                              countries[0] +
                              "&lang=" +
                              this.$i18n.locale,
                          )
                          .then((c) => {
                            this.goods_origin = c.data[0].display_text;
                          });
                      }
                      this.contract_total += total;
                    });
                }
                if (item.DocType == "CMR") {
                  axios
                    .get(
                      window.base +
                        "/Document/LoadCMR/?doc_id=" +
                        item.DocumentID,
                    )
                    .then((cmr) => {
                      this.delivery_country = cmr.data.DeliveryPlace;
                      this.delivery_from =
                        cmr.data.City + ", " + cmr.data.StreetHouse;
                      // this.delivery_address =
                      if (cmr.data.cmr_courier !== "") {
                        axios
                          .get(
                            window.base +
                              "/document/getFirmbyBin?bin=" +
                              cmr.data.cmr_courier,
                          )
                          .then((courier) => {
                            this.courier_org_name =
                              courier.data.organizations.org_name;
                          });
                      }
                    });
                }
              });
              if (this.template) {
                const compiledFunction = pug.compile(this.template);
                this.pugTemplate = compiledFunction({
                  doc_id: this.doc_id,
                  city: this.city,
                  day: this.day,
                  month: this.month,
                  year: this.year,
                  org1_type: this.org1_type,
                  org1_name: this.org1_name,
                  org1_residency: this.org1_residency,
                  org1_address: this.org1_address,
                  org1_ceo: this.org1_ceo,
                  org2_type: this.org2_type,
                  org2_name: this.org2_name,
                  org2_residency: this.org2_residency,
                  org2_address: this.org2_address,
                  org2_ceo: this.org2_ceo,
                  delivery_terms: this.delivery_terms,
                  goods_origin: this.goods_origin,
                  delivery_from: this.delivery_from,
                  delivery_country: this.delivery_country,
                  courier_org_name: this.courier_org_name,
                  contract_currency: this.contract_currency,
                  conditions: this.conditions,
                  days_to_change_price: this.days_to_letters(
                    this.conditions.days_to_change_price,
                  ),
                  contract_total: this.contract_total,
                  contract_money_letters: this.money_letters(
                    this.contract_total,
                    this.contract_currency_code,
                  ),
                  contract_currency: this.contract_currency,
                  prepayment_percent: this.percent_to_letters(
                    this.conditions.prepayment_percent,
                  ),
                  prepayment_days: this.days_to_letters(
                    this.conditions.number_of_days_for_prepayment,
                  ),
                  conditions100percent: this.percent_to_letters(
                    100 - this.conditions.prepayment_percent,
                  ),
                  conditions100days: this.days_to_letters(
                    this.conditions.number_of_days_for_fullpayment,
                  ),
                  goods: this.goods,
                });
              }
              setTimeout(() => {
                //load signature from database
                axios
                  .get(
                    window.base +
                      "/contract/LoadSignature?doc_id=" +
                      this.doc_id,
                  )
                  .then((response) => {
                    if (typeof response.data.signature !== "undefined") {
                      if (response.data.signature == "") {
                        this.$root.$emit("print-pdf", {
                          signature: "",
                          type: "contract",
                        });
                        new Noty({
                          theme: "light",
                          type: "error",
                          text: this.$t(
                            "message.contracts.no-signature-message",
                          ),
                          timeout: 5000,
                        }).show();
                      } else {
                        var canvas = QRCode.toCanvas(response.data.signature, {
                          width: 100,
                          height: 100,
                        });
                        canvas.then((r) => {
                          // this.check_signature(value, ()=>{
                          this.$root.$emit("print-pdf", {
                            signature: r,
                            type: "contract",
                          });
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t(
                              "message.contracts.yes-signature-message",
                            ),
                            timeout: 5000,
                          }).show();
                          // window.webSocket.removeEventListener('message', {})
                          // })
                        });
                      }
                    } else {
                      this.$root.$emit("print-pdf", {
                        signature: "",
                        type: "contract",
                      });
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t("message.contracts.no-signature-message"),
                        timeout: 5000,
                      }).show();
                    }
                  });
              }, 1000);
            });
        });
    }
  },
  methods: {
    /**
     * format address object to printed contract text
     */
    form_address(address) {
      let result = [];
      let country = "";
      if (
        typeof address.post_addr_country !== "undefined" &&
        address.post_addr_country !== ""
      ) {
        axios
          .get(
            window.base +
              "/library/country?code=" +
              address.post_addr_country +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            if (typeof response.data[0] !== "undefined") {
              country = response.data[0].display_text;
            }
          });
      }
      if (
        typeof address.post_addr_index !== "undefined" &&
        address.post_addr_index !== ""
      ) {
        result.push(address.post_addr_index);
      }
      if (
        typeof address.post_addr_city !== "undefined" &&
        address.post_addr_city !== ""
      ) {
        result.push(address.post_addr_city);
      }
      if (
        typeof address.post_addr_town !== "undefined" &&
        address.post_addr_town !== ""
      ) {
        result.push(address.post_addr_town);
      }
      if (
        typeof address.post_addr_streethouse !== "undefined" &&
        address.post_addr_streethouse !== ""
      ) {
        result.push(address.post_addr_streethouse);
      }
      if (
        typeof address.post_addr_house !== "undefined" &&
        address.post_addr_house !== ""
      ) {
        result.push(address.post_addr_house);
      }
      if (
        typeof address.post_addr_room !== "undefined" &&
        address.post_addr_room !== ""
      ) {
        result.push(address.post_addr_room);
      }
      console.log(address);
      return (country !== "" ? country + ", " : "") + result.join(", ");
    },
    /**
     * proxy to call external function in template
     */
    number_to_letters(val) {
      if (this.$i18n.locale == "en") return window.number_to_letters_en(val);
      else return window.number_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    days_to_letters(val) {
      if (this.$i18n.locale == "en") return window.days_to_letters_en(val);
      else return window.days_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    money_letters(val, cur) {
      if (this.$i18n.locale == "en") return window.money_letters_en(val, cur);
      else return window.money_letters(val, cur);
    },
    /**
     * proxy to call external function in template
     */
    percent_to_letters(val) {
      if (this.$i18n.locale == "en") return window.percent_to_letters_en(val);
      else return window.percent_to_letters(val);
    },
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios.post(window.base + "/contract/CheckSignature", fd).then((r) => {
        if (r.data == "False") {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.document_signature_is_wrong"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.document_signature_is_ok"),
            timeout: 5000,
          }).show();
          callback();
        }
      });
    },
    callback(r) {
      if (r.code == "200") {
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "contract" });
            window.webSocket.removeEventListener("message", {});
          });
        });
      }
    },
  },
  watch: {},
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    contract_currency() {
      return this.doc.attis_contract_currency.display_text;
    },
    contract_currency_code() {
      return this.doc.attis_contract_currency.value;
    },
    delivery_terms() {
      return (
        '"' +
        this.doc.attis_contract_delivery_term.value +
        ": " +
        this.doc.attis_contract_delivery_term.display_text +
        '"'
      );
    },
    day() {
      return moment(this.doc.attis_contract_date).format("D");
    },
    month() {
      return moment(this.doc.attis_contract_date).format("MMMM");
    },
    year() {
      return moment(this.doc.attis_contract_date).format("Y");
    },
    date() {
      return moment().format("D.MM.Y");
    },
    document_date() {
      // this.doc.attis_contract_create_date
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  font-size: 1.2em;
}
.subline {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
.html2pdf__page-break {
  page-break-before: always;
}
</style>
